import styled from "styled-components";

export const SocialWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  min-width: 0;
  height: clamp(520px, 42vw, 592px);
  overflow: hidden;

  /* Ensure the notebook image defines the size of the wrapper */
  .background-card {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .socialframe-card {
    display: block;
    width: 100%;
    height: 33rem;
  }
  .title {
    font-size: clamp(24px, 2.6vw, 35px);
    font-weight: 800;
    color: #003f3d;
    background-color: #cedfdf;
    position: absolute;
    top: 20%;
    left: 18%;
     rotate: 2.1deg;
   
    z-index: 5;
  }

  /* Replaces your old .post class to handle the iframe */
  .post-container {
    position: absolute;
    top: 27%;
    width: 70%;
    left: 11.5%;
    right: auto;
    height: 72%;
    z-index: 5;
     /* Keeps the post aligned with the notebook lines */

    .frame {
      display: block;
      width: 100%;
      height: auto;
      pointer-events: none; /* decorative */
    }

    .thumbnail {
      position: absolute;
      left: 10%; /* tweak to fit inside the decorative frame */
      top: 14%;
      width: 80%;
      height: 50%;
        rotate: 1.1deg;
      object-fit: cover;
      border-radius: 8px;
      box-shadow: 0 6px 18px rgba(0,0,0,0.25);
      cursor: pointer;
    }

    .play-btn {
      position: absolute;
      left: 50%;
      top: 35%;
      transform: translate(-50%, -50%);
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background: #fff;
      color: #003f3d;
      font-size: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      cursor: pointer;
      z-index: 6;
      box-shadow: 0 6px 18px rgba(0,0,0,0.25);
    }

    .video-title {
      position: absolute;
      bottom: 14%;
      left: 50%;
      transform: translateX(-50%);
      width: 60%;
      text-align: center;
      color: #003f3d;
      background-color: #cedfdf;
      font-weight: 700;
      z-index: 6;
    }
  }

  .nav-btn {
    position: absolute;
    top: 60%;
    transform: translateY(-50%); /* Perfectly centers the button on the Y-axis */
    width: clamp(38px, 4vw, 50px);
    height: clamp(42px, 4.5vw, 56px);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    background: #005856;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: transform 0.2s ease-in-out;

    svg {
      font-size: 36px;
      color: #fff;
    }

    &:hover {
      /* Keep the Y translation when scaling */
      transform: translateY(-50%) scale(1.05); 
    }
  }

  .left {
    left: 6%;
  }

  .right {
    right: 9%;
  }

  /* New styles for the carousel dots */
  .story-radio-group {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .pagination {
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
    rotate: 2.1deg;

    .dot {
      width: 12px;
      height: 12px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: #454545;
      cursor: pointer;
      transition: background 0.3s ease;

      &:focus-visible {
        outline: 2px solid #005856;
        outline-offset: 4px;
      }
      
      &.active {
        background: #843500;
      }
    }
  }

  /* Modal styles */
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 30000;
    padding: 24px;
  }

  .modal-content {
    position: relative;
    width: min(1100px, 95%);
    background: #000;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.6);
  }

  .modal-topbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 10px 14px;
    background: #111;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }

  .modal-iframe {
    width: 100%;
    height: 62vh;
    display: block;
  }

  .modal-close,
  .modal-maximize {
    position: static;
    background: #333333;
    color: #fff;
    border: 1px solid rgba(255,255,255,0.4);
    width: 40px;
    height: 40px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 10;
    flex-shrink: 0;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.18s;
  }

  .modal-close:hover,
  .modal-maximize:hover {
    background: #444444;
  }

  @media (max-width: 640px) {
    height: clamp(430px, 135vw, 520px);

    .title {
      top: 13%;
      left: 16%;
      max-width: 68%;
      font-size: clamp(21px, 7vw, 28px);
      line-height: 1.15;
    }

    .post-container {
      top: 27%;
      left: 12%;
      width: 76%;
      height: 68%;

      .thumbnail {
        height: 48%;
      }

      .play-btn {
        width: 52px;
        height: 52px;
        font-size: 21px;
      }

      .video-title {
        bottom: 15%;
        width: 72%;
        font-size: 14px;
      }
    }

    .nav-btn {
      top: 58%;
    }

    .left {
      left: 4%;
    }

    .right {
      right: 4%;
    }

    .pagination {
      bottom: 5%;
    }

    .modal-overlay {
      padding: 12px;
    }

    .modal-content {
      width: 100%;
    }

    .modal-iframe {
      height: auto;
      min-height: 220px;
      aspect-ratio: 16 / 9;
    }
  }
`;
